export default "__VITE_ASSET__C3m0Cc9Q__"